<template>
  <div v-if="visible">
    <el-dialog
      :zIndex="10000"
      top="0vh"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :footer="null"
      :show-close="false"
      class="general-loading-dialog"
    >
      <el-row class="loading-box" type="flex" justify="center" align="middle">
        <i
          type="sync"
          style="font-size: 48px; margin: 5px 10px"
          spin
          class="el-icon-loading"
        />
        <span class="loading-message">{{ message }}</span>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "Loading",
  data() {
    return {
      immediately: true,
      visible: false,
      message: "Loading...",
    };
  },
  mounted() {},
  methods: {
    Open(message) {
      this.message = message;
      this.immediately = true;
      setTimeout(this.handleOpen, 1500);
    },
    handleOpen() {
      if (this.immediately) {
        this.visible = true;
        NProgress.start();
      }
    },
    Close() {
      this.visible = false;
      this.immediately = false;
      NProgress.done();
    },
  },
};
</script>

<style lang="scss">
.general-loading-dialog {
  height: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  .el-dialog {
    max-height: 150px !important;
    min-height: 50px !important;
    max-width: 500px !important;
    min-width: 200px !important;
    display: flex;
    flex-direction: column;
    position: relative !important;
    border-radius: 5px;
    width: auto !important;

    .el-dialog__body {
      flex: 1;
      height: 99% !important;
      overflow: hidden;
      position: relative !important;
      padding-bottom: 10px !important;
      padding: 15px;
    }

    .el-dialog__header {
      display: none !important;
    }
  }
}
.loading-box {
  padding: 10px 20px;
}
.loading-icon {
  font-size: 32px;
  color: #000;
  margin: 20px;
}
.loading-message {
  font-size: 20px;
  flex: 1;
  color: #000;
}
</style>
